import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  setHref(url: string): void {
    window.location.href = url;
  }
}
